#import "./PolicyAdminFields.graphql"

mutation CreatePolicy($policyInput: PolicyInput!) {
  createPolicy(input: { policyInput: $policyInput }) {
    policy {
      ...PolicyAdminFields
    }
  }
}
